import * as React from 'react';
import { Tag } from 'sha-el-design/lib';
import { WorkStatusEnum } from '../../schema';

export const workStatusTag = (status: WorkStatusEnum) => {
  switch (status) {
    case WorkStatusEnum.FINNISHED: {
      return <Tag color='#00f600' >{status}</Tag>;
    }
    case WorkStatusEnum.DOING: {
      return <Tag color='#660000' >{status}</Tag>;
    }
    case WorkStatusEnum.PENDING: {
      return <Tag color='#FF6600' >{status}</Tag>;
    }
    case WorkStatusEnum.ON_HOLD: {
      return <Tag color='#F00000'>{status}</Tag>;
    }
  }
};
